
export const dealerRegistration = {
  hero: {
    badge: 'DEVENIR PARTENAIRE',
    title: 'Devenez Revendeur Officiel Dutch Fires',
    subtitle: 'Rejoignez notre réseau exclusif de partenaires professionnels et bénéficiez de produits premium, de marges attractives et d\'un soutien complet.'
  },
  benefits: {
    title: 'Pourquoi S\'Associer avec Dutch Fires?',
    benefit1: {
      icon: 'ri-price-tag-3-line',
      title: 'Prix de Gros Attractifs',
      description: 'Bénéficiez de prix compétitifs et de marges élevées pour votre entreprise'
    },
    benefit2: {
      icon: 'ri-shield-check-line',
      title: 'Droits de Territoire Exclusifs',
      description: 'Sécurisez votre territoire et minimisez la concurrence'
    },
    benefit3: {
      icon: 'ri-customer-service-2-line',
      title: 'Support Complet',
      description: 'Marketing, formation technique et accompagnement personnel'
    },
    benefit4: {
      icon: 'ri-truck-line',
      title: 'Livraison Flexible',
      description: 'Dropshipping, stock ou livraison de projet au choix'
    }
  },
  requirements: {
    title: 'Exigences pour Devenir Revendeur',
    subtitle: 'Pour devenir revendeur officiel Dutch Fires, nous demandons:',
    req1: 'Entreprise enregistrée (Chambre de Commerce ou équivalent)',
    req2: 'Actif dans le secteur des cheminées, de l\'intérieur ou de la construction',
    req3: 'Showroom professionnel ou présence en ligne',
    req4: 'Engagement envers la qualité et le service client'
  },
  form: {
    title: 'Formulaire d\'Inscription',
    subtitle: 'Remplissez le formulaire ci-dessous et nous vous contactons sous 1-2 jours ouvrables.',
    companyName: 'Nom de l\'Entreprise',
    companyNamePlaceholder: 'Nom de votre entreprise',
    contactPerson: 'Personne de Contact',
    contactPersonPlaceholder: 'Prénom et nom',
    email: 'Adresse Email',
    emailPlaceholder: 'votre.email@entreprise.fr',
    phone: 'Numéro de Téléphone',
    phonePlaceholder: '+33 1 23 45 67 89',
    website: 'Site Web',
    websitePlaceholder: 'www.votreentreprise.fr',
    country: 'Pays',
    countryPlaceholder: 'Sélectionnez votre pays',
    industry: 'Secteur',
    industryPlaceholder: 'Sélectionnez votre secteur',
    message: 'Message',
    messagePlaceholder: 'Parlez-nous de votre entreprise et pourquoi vous souhaitez devenir revendeur Dutch Fires...',
    submit: 'Envoyer la Candidature',
    submitting: 'Envoi en cours...',
    success: 'Merci pour votre candidature! Nous vous contacterons sous 1-2 jours ouvrables.',
    error: 'Une erreur s\'est produite. Veuillez réessayer ou nous contacter directement.',
    required: 'Ce champ est obligatoire',
    invalidEmail: 'Adresse email invalide',
    industries: {
      fireplace: 'Magasin de Cheminées',
      interior: 'Magasin d\'Intérieur',
      construction: 'Entreprise de Construction',
      ecommerce: 'E-commerce',
      other: 'Autre'
    }
  },
  process: {
    title: 'Que Se Passe-t-il Après Votre Candidature?',
    step1: {
      title: 'Vérification',
      description: 'Nous examinons vos informations commerciales et évaluons votre candidature'
    },
    step2: {
      title: 'Contact Personnel',
      description: 'Un de nos gestionnaires de compte vous contactera'
    },
    step3: {
      title: 'Intégration',
      description: 'Accès au portail revendeur, formation et matériel marketing'
    },
    step4: {
      title: 'Commencer à Vendre',
      description: 'Commencez à vendre et bénéficiez de notre soutien'
    }
  },
  cta: {
    title: 'Des Questions? Contactez-Nous Directement',
    email: 'info@dutchfires.de'
  }
};
